export default __webpack_public_path__ + "assets/cb3b6cfe8e427d5807bdd9057d665d76.png";